import backendVerifiedUser from "../../api/backendVerifiedUser";
import backendValidUserForFile from "../../api/backendVerifiedUserForFile";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import { SET_SETUP, SET_COUPON_IMAGES, SET_BANNER_IMAGES } from "../Types/SetupTypes";

export const getSetupDetails = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/setup-details");

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SETUP, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const updateSetupDetails = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendValidUserForFile.post(
        "/setup-details",
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const updateHeroSection = (data) => {
  console.log(data);
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        "/setup-details/hero-section",
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const uploadBannerImage = (data) => {
  console.log(data);
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendValidUserForFile.post(
        "/setup-details/banner-image",
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};
export const deleteBannerImage = (id) => {
 
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.delete(
        `/setup-details/banner-image/${id}`
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};
export const getBannerImages = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        "/setup-details/banner-image"
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_BANNER_IMAGES, payLoad: response.data });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const updateContactSection = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      console.log(data);
      const response = await backendValidUserForFile.post(
        "/setup-details/contact-section",
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getCouponImages = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/coupon-images");
      dispatch({ type: CLOSE_LOADER });

      dispatch({
        type: SET_COUPON_IMAGES,
        payLoad: response.data,
      });
    } catch (err) {
      console.log(err);
      dispatch({ type: CLOSE_LOADER });
      dispatch({
        type: SET_ERROR,
        payLoad: err?.response?.data?.error || "Failed to load coupon images",
      });
    }
  };
};

// 🔽 Upload New Images (waits for form submission)
export const uploadCouponImages = (files) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });

    try {
      const formData = new FormData();
      formData.append("coupon", files[0]); // must match multer field name
      console.log(files[0]);
      const response = await backendValidUserForFile.post(
        "/coupon-images/upload",
        formData
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({
        type: SET_SUCCESS,
        payLoad: "Images uploaded successfully",
      });
      dispatch(getCouponImages());

      return true;
    } catch (err) {
      console.log(err);
      dispatch({ type: CLOSE_LOADER });
      dispatch({
        type: SET_ERROR,
        payLoad: err?.response?.data?.error || "Image upload failed",
      });
      return false;
    }
  };
};

// 🔽 Delete Image from backend
export const deleteCouponImage = (filename) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      await backendValidUserForFile.delete(`/coupon-images/${filename}`);
      dispatch({ type: CLOSE_LOADER });

      dispatch({
        type: SET_SUCCESS,
        payLoad: "Image deleted successfully",
      });

      // Optionally refresh
      dispatch(getCouponImages());
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({
        type: SET_ERROR,
        payLoad: err?.response?.data?.error || "Failed to delete image",
      });
    }
  };
};

// 🔽 Save new image order
export const setCouponImageOrder = (orderArray) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      await backendValidUserForFile.post("/coupon-images/order", orderArray);
      dispatch({ type: CLOSE_LOADER });

      dispatch({
        type: SET_SUCCESS,
        payLoad: "Image order updated",
      });

      // Refresh to reflect changes
      dispatch(getCouponImages());
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      dispatch({
        type: SET_ERROR,
        payLoad: err?.response?.data?.error || "Failed to save order",
      });
    }
  };
};
